import { Screen } from "flemo";

import { AuthGuard } from "@/components/AuthGuard";
import { useAuthStore } from "@/store/authStore";

import { AvatarSection } from "./_components/AvatarSection";
import { DeleteAccountDialog } from "./_components/DeleteAccountDialog";
import { Header } from "./_components/Header";
import { LogoutSection } from "./_components/LogoutSection";
import { ProfileInfoSection } from "./_components/ProfileInfoSection";

export function ProfilePage() {
  const user = useAuthStore(state => state.user);

  return (
    <Screen>
      <AuthGuard>
        <main className="h-screen bg-muted flex flex-col overflow-y-auto pt-safe pb-safe">
          <Header />

          <div className="mx-auto max-w-3xl w-full flex flex-col flex-1 pt-6 pb-10 px-5">
            {user && (
              <>
                <AvatarSection />
                <ProfileInfoSection user={user} />
              </>
            )}

            <LogoutSection />
            {user && <DeleteAccountDialog />}
          </div>
        </main>
      </AuthGuard>
    </Screen>
  );
}
